<button class="collection-card" (click)="handleClick()">
  @if (collection.ImageUrl) {
    <img [src]="collection.ImageUrl" [alt]="collection.Title" />
  }
  <div class="collection-info">
    <h3>{{collection.Title}}</h3>
    @if (collection.Description) {
      <p>{{collection.Description}}</p>
    }
  </div>
</button>
